import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';
import { FiArrowRight, FiCalendar, FiUser } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Blog = () => {
  return (
    <div className="page-transition pt-36 pb-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl mb-6">Journal</h1>
          <p className="text-lg text-brand-600 max-w-2xl mx-auto">
            Stories, updates, and insights from paradise.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {blogPosts.map((post) => (
            <Link 
              to={`/blog/${post.id}`} 
              key={post.id}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-brand-100 flex flex-col h-full"
            >
              <div className="relative h-64 overflow-hidden">
                <video 
                  src="https://canv.wasacon.com/amani-resort-zanzibar/_assets/video/eae82d0564857a215475c13dfd6b0941.mp4" 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 text-xs font-bold uppercase tracking-widest text-brand-900 rounded-sm">
                  {post.category}
                </div>
              </div>
              
              <div className="p-8 flex flex-col flex-grow">
                <div className="flex items-center gap-4 text-xs text-brand-500 mb-4 font-medium uppercase tracking-wider">
                  <span className="flex items-center gap-1">
                    <SafeIcon icon={FiCalendar} /> {post.date}
                  </span>
                </div>

                <h2 className="text-2xl font-serif text-brand-900 mb-4 leading-tight group-hover:text-brand-600 transition-colors">
                  {post.title}
                </h2>
                
                <p className="text-brand-600 mb-6 line-clamp-3 leading-relaxed flex-grow">
                  {post.excerpt}
                </p>

                <div className="flex items-center text-brand-800 font-bold uppercase text-xs tracking-widest group-hover:translate-x-2 transition-transform duration-300">
                  Read Article <SafeIcon icon={FiArrowRight} className="ml-2" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;